import React, { Component } from 'react'
import GoogleMap from 'google-map-react'
import MainMarker from './MainMarker'
import { withStyles, Grid } from '@material-ui/core'

const styles = theme => ({
  similarProps: {
    padding: '35px 32px 23px',
    [theme.breakpoints.down('sm')]: {
      padding: '35px 32px 70px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '22px 15px 15px',
    },
    '& h5': {
      fontSize: '29px',
      fontWeight: '300',
      color: '#231f20',
      margin: '0 0 23px',
      [theme.breakpoints.down('xs')]: {
        margin: '0 0 16px',
        fontSize: '20px',
      },
    },
  },
})

/*
 Google Maps component
*/
class MapPropertyDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      zoom: 12,
      center: this.props.center,
    }
  }

  render() {
    const { center, mobile, classes } = this.props
    const { zoom } = this.state
    let zoomMap = isNaN(zoom) ? process.env.REACT_APP_DEFAULT_ZOOM : zoom

    const createMapOptions = maps => {
      return {
        zoomControl: !mobile,
        minZoom: 7,
        maxZoom: 19,
        fullscreenControl: !mobile,
        fullscreen: !!mobile,
        gestureHandling: 'greedy',
        styles: [
          {
            stylers: [{ visibility: 'on' }, { saturation: -100 }, { gamma: 0.8 }, { lightness: 4 }],
          },
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }],
          },
        ],
      }
    }

    return (
      <Grid item xs={12}>
        <Grid container className={classes.similarProps}>
          <Grid item xs={12}>
            <h5>Map View</h5>
          </Grid>
          <Grid item xs={12}>
            <Grid container style={{ height: '50vh', width: '100%' }}>
              <GoogleMap
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_TOKEN }}
                options={createMapOptions}
                hoverDistance={30}
                center={center}
                zoom={zoomMap}>
                <MainMarker lat={center.lat} lng={center.lng} />
              </GoogleMap>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(MapPropertyDetail)



// WEBPACK FOOTER //
// ./src/components/map/MapPropertyDetailModal.js